import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import '../css/CustomCard.css'; // Tell webpack that Button.js uses these styles
import { Link } from 'react-router-dom';


class CusCard extends React.Component {
    constructor(props) {
        super(props);
        
    }

    render() {
        return (
            <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Link className="text-decoration-none" to={this.props.link}>
                <Card className="card p-3 text-center bg-Card mb-1" style={{ margin: 'auto', boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
                    <div className="card-content mt-3" style={{ margin: 'auto' }}>
                        <div className="avatarCustomCard">
                            <div className="avatarCustomCard-content">
                                <FeatherIcon color="black" icon={this.props.icon} size="30" />
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Card.Body className="pt-2">
                                <Card.Text className="fontstyling">
                                    {this.props.data1} <br></br> {this.props.data2}
                                         </Card.Text>
                            </Card.Body>
                        </div>
                    </div>
                </Card>
                </Link>

            </div>

        );
    }
}

export default CusCard;